module.exports = "<div class=preloader> <i class=\"fa fa-spinner fa-spin\"></i> </div>";